var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-info"},[_c('div',[_c('card-header'),_c('tabs',{attrs:{"tabs":_vm.tabs,"active":_vm.activeTab},on:{"setTab":_vm.setTab}}),(_vm.activeTab === 0 && _vm.id)?_c('info',{attrs:{"id":_vm.id}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }